import React, { Component } from "react"
import { Link } from "react-router-dom"
import config from "react-global-configuration"
import * as path from "../../constants/Paths"
import SimpleErrorModal from "../../../shared/modal/simple-error-modal"
import * as endpoints from "../../constants/Endpoints"
import Spinner from "../spinner"
import axios from "axios"

class AmendInformation extends Component {
  state = {
    firstName: "",
    lastName: "",
    email: "",
    mobilePhone: "",
    vehicleRegistrationNumber: "",
    vehicleModel: "",
    vehicleMake: "",
    vehicleColour: "",
    showErrorModal: false,
    modalOpen: true,
    timeout: undefined,
    loaderActive: false,
    ajaxSpinnerActive: false,
  }

  componentDidMount() {
    if (this.props.manageBookingResult)
      this.setState({
        firstName: this.props.manageBookingResult.booking.firstName,
        lastName: this.props.manageBookingResult.booking.lastName,
        email: this.props.manageBookingResult.booking.email,
        mobilePhone: this.props.manageBookingResult.booking.mobilePhone,
        vehicleRegistrationNumber: this.props.manageBookingResult.booking.vehicleRegistrationNumber,
        vehicleModel: this.props.manageBookingResult.booking.vehicleModel,
        vehicleMake: this.props.manageBookingResult.booking.vehicleMake,
        vehicleColour: this.props.manageBookingResult.booking.vehicleColour,
      })
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.manageBookingResult) {
      if (!prevProps.manageBookingResult || prevProps.manageBookingResult.booking !== this.props.manageBookingResult.booking) {
        this.setState({
          firstName: this.props.manageBookingResult.booking.firstName,
          lastName: this.props.manageBookingResult.booking.lastName,
          email: this.props.manageBookingResult.booking.email,
          mobilePhone: this.props.manageBookingResult.booking.mobilePhone,
          vehicleRegistrationNumber: this.props.manageBookingResult.booking.vehicleRegistrationNumber,
          vehicleModel: this.props.manageBookingResult.booking.vehicleModel,
          vehicleMake: this.props.manageBookingResult.booking.vehicleMake,
          vehicleColour: this.props.manageBookingResult.booking.vehicleColour,
        })
      }
    }
  }

  handleInputChange = (event, maxLength) => {
    const { target } = event
    const value = target.value.slice(0, maxLength)
    this.setState({ [target.name]: value })
  }

  handleModitfyInformation = (state) => {
    const data = {
      firstName: state.firstName,
      lastName: state.lastName,
      email: state.email,
      mobilePhone: state.mobilePhone,
      vehicleRegistrationNumber: state.vehicleRegistrationNumber,
      vehicleModel: state.vehicleModel,
      vehicleMake: state.vehicleMake,
      vehicleColour: state.vehicleColour,
    }
    this.props.modifyBookingInformation(data, () => {
      this.props.history.push({
        pathname: path.AMMEND_SHOW_BOOKING(),
        search: this.props.location.search,
      })
    })
    this.setState({
      ajaxSpinnerActive: true,
    })
  }

  handleLicensePlateInput = (event, maxLength) => {
    this.handleInputChange(event, maxLength)
    const target = event.target
    const value = target.value
    if (this.state.timeout) {
      clearTimeout(this.state.timeout)
      this.setState({ timeout: undefined })
    }
    this.setState({
      timeout: setTimeout(() => {
        if (value.replaceAll(/\s/g, "").length >= 7) {
          target.blur()
        }
      }, 300),
    })
  }

  verifyLicensePlate = (value) => {
    if (value.length > 0) {
      this.setState({ loaderActive: true })
      axios
        .get(endpoints.VERIFY_LICENSE_PLATE(value))
        .then((res) => {
          if (res && res.status === 204) {
            this.showErrorModal(value)
          }
          return res.data
        })
        .then((data) => {
          for (const key in data) {
            switch (key) {
              case "make":
                this.setState({ vehicleMake: data.make })
                break
              case "model":
                this.setState({ vehicleModel: data.model })
                break
              case "color":
                this.setState({ vehicleColour: data.color })
                break
              case "licensePlate":
                this.setState({ vehicleRegistrationNumber: data.licensePlate.replaceAll(" ", "") })
                break
              default:
                break
            }
          }
        })
        .finally(() => {
          this.setState({ loaderActive: false })
        })
    }
  }

  showErrorModal(input) {
    const textKeys = config.get("textKeys.checkout.vehicleRegistrationValidationModal") || {}
    this.setState({
      showErrorModal: true,
      errorData: {
        h3: textKeys.vehicleRegistrationModalErrorHeader || "Din nummerplade kunne ikke valideres",
        richText:
          textKeys.vehicleRegistrationModalErrorMessage?.replace("{value}", input) ||
          "<p>Er du sikker på at <strong>{value}</strong> er en gyldig nummerplade?</p>".replace("{value}", input),
      },
    })
  }

  handleModalClose = () => {
    this.setState({ showErrorModal: false })
  }

  render() {
    if (!this.props.manageBookingResult) return null
    const { booking } = this.props.manageBookingResult
    const textKeys = config.get("textKeys.amendment.editInfo") || {}
    const personalValidationTextKeys = config.get("textKeys.checkout.billingValidationMessages") || {}
    const vehicleValidationTextKeys = config.get("textKeys.checkout.vehicleValidationMessages") || {}

    const now = new Date(Date.now())
    const bookingDate = booking.arrivalDate
    const bookingTime = booking.arrivalTime

    const bookingDateTime = new Date(`${bookingDate}T${bookingTime}`)
    const isBookingActive = now >= bookingDateTime

    return (
      <React.Fragment>
        <Spinner isActive={this.state.ajaxSpinnerActive} isTransparent={this.props.ajaxSpinnerTransparent} />
        <section className="deck deck--white deck--padding-bottom form form--parking js--parking-form">
          <div className="form--parking__essentials">
            <div className="form__section form__section--no-border">
              <div className="w--narrow">
                <h4>{textKeys.personalText ? textKeys.personalText.header || "Din information" : "Din information"}</h4>
                <div className="form__section__inner">
                  <div className={`form__field form__field--text is-filled is-bound ${this.state.firstName?.length > 50 ? "is-invalid" : ""}`}>
                    <span className="form__valid" />
                    <input
                      className="form__item "
                      name="firstName"
                      type="text"
                      autoComplete="given-name"
                      value={this.state.firstName}
                      onChange={(event) => this.handleInputChange(event, 50)}
                    />
                    <label className="form__label">
                      <span className="form__label__text">
                        {textKeys.personalText ? textKeys.personalText.firstname || "Fornavn" : "Fornavn"}&nbsp;&nbsp;<strong>&nbsp;</strong>
                      </span>
                    </label>
                    {this.state.firstName?.length > 50 ? (
                      <span className="form__notice">
                        {this.props.validationMessageReplace(this.state.firstName, personalValidationTextKeys.firstnameMessage) ||
                          "Dit input er for langt."}
                      </span>
                    ) : null}
                  </div>
                  <div className={`form__field form__field--text is-filled is-bound ${this.state.lastName?.length > 50 ? "is-invalid" : ""}`}>
                    <span className="form__valid" />
                    <input
                      className="form__item "
                      name="lastName"
                      autoComplete="family-name"
                      type="text"
                      value={this.state.lastName}
                      onChange={(event) => this.handleInputChange(event, 50)}
                    />
                    <label className="form__label">
                      <span className="form__label__text">
                        {textKeys.personalText ? textKeys.personalText.lastname || "Efternavn" : "Efternavn"}&nbsp;&nbsp;<strong>&nbsp;</strong>
                      </span>
                    </label>
                    {this.state.lastName?.length > 50 ? (
                      <span className="form__notice">
                        {this.props.validationMessageReplace(this.state.lastName, personalValidationTextKeys.lastnameMessage) ||
                          "Dit input er for langt."}
                      </span>
                    ) : null}
                  </div>
                  <div className={`form__field form__field--text is-filled is-bound ${this.state.email?.length > 100 ? "is-invalid" : ""}`}>
                    <span className="form__valid" />
                    <input
                      className="form__item "
                      name="email"
                      type="email"
                      autoComplete="email"
                      value={this.state.email}
                      onChange={(event) => this.handleInputChange(event, 100)}
                    />
                    <label className="form__label">
                      <span className="form__label__text">
                        {textKeys.personalText ? textKeys.personalText.email || "E-mail" : "E-mail"}&nbsp;&nbsp;<strong>&nbsp;</strong>
                      </span>
                    </label>
                    {this.state.email?.length > 100 ? (
                      <span className="form__notice">
                        {this.props.validationMessageReplace(this.state.email, personalValidationTextKeys.emailMessage) || "Dit input er for langt."}
                      </span>
                    ) : null}
                  </div>
                  <div className={`form__field form__field--text is-filled is-bound ${this.state.mobilePhone?.length > 20 ? "is-invalid" : ""}`}>
                    <span className="form__valid" />
                    <input
                      className="form__item "
                      name="mobilePhone"
                      type="tel"
                      autoComplete="tel"
                      value={this.state.mobilePhone}
                      onChange={(event) => this.handleInputChange(event, 20)}
                    />
                    <label className="form__label">
                      <span className="form__label__text">
                        {textKeys.personalText ? textKeys.personalText.mobilenumber || "Mobilnr." : "Mobilnr."}&nbsp;&nbsp;<strong>&nbsp;</strong>
                      </span>
                    </label>
                    {this.state.mobilePhone?.length > 20 ? (
                      <span className="form__notice">
                        {this.props.validationMessageReplace(this.state.mobilePhone, personalValidationTextKeys.mobilenumberMessage) ||
                          "Dit input er for langt."}
                      </span>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="form--parking__vechicle-info">
            <div className="form__section form__section--no-border form__section">
              <div className="w--narrow">
                <h4>{textKeys.vehichleText ? textKeys.vehichleText.header || "Bilens oplysninger" : "Bilens oplysninger"}</h4>
                <div className="form__section__inner">
                  <div
                    className={`form__field form__field--text is-filled is-bound ${
                      this.state.vehicleRegistrationNumber?.length > 20 ? "is-invalid" : ""
                    }`}
                  >
                    <span className="form__valid" />
                    <input
                      className="form__item "
                      name="vehicleRegistrationNumber"
                      type="text"
                      disabled={isBookingActive ? true : false}
                      value={this.state.vehicleRegistrationNumber}
                      onChange={(event) => this.handleLicensePlateInput(event, 20)}
                      onBlur={(event) => this.verifyLicensePlate(event.target.value)}
                    />
                    <label className="form__label">
                      <span className="form__label__text">
                        {textKeys.vehichleText ? textKeys.vehichleText.vehicleRegistrationNumber || "Registreringsnr." : "Registreringsnr."}
                        &nbsp;&nbsp;<strong>&nbsp;</strong>
                      </span>
                    </label>
                    {this.state.loaderActive ? <div className={"input-spinner"}></div> : ""}
                    {this.state.vehicleRegistrationNumber?.length > 20 ? (
                      <span className="form__notice">
                        {this.props.validationMessageReplace(
                          this.state.vehicleRegistrationNumber,
                          vehicleValidationTextKeys.vehicleRegistrationNumberMessage,
                        ) || "Dit input er for langt."}
                      </span>
                    ) : null}
                  </div>
                  <div className={`form__field form__field--text is-filled is-bound ${this.state.vehicleMake?.length > 50 ? "is-invalid" : ""}`}>
                    <span className="form__valid" />
                    <input
                      className="form__item "
                      name="vehicleMake"
                      type="text"
                      disabled={isBookingActive ? true : false}
                      value={this.state.vehicleMake}
                      onChange={(event) => this.handleInputChange(event, 50)}
                    />
                    <label className="form__label">
                      <span className="form__label__text">
                        {textKeys.vehichleText ? textKeys.vehichleText.vehicleMake || "Mærke" : "Mærke"}&nbsp;&nbsp;<strong>&nbsp;</strong>
                      </span>
                    </label>
                    {this.state.vehicleMake?.length > 50 ? (
                      <span className="form__notice">
                        {this.props.validationMessageReplace(this.state.vehicleMake, vehicleValidationTextKeys.vehicleMakeMessage) ||
                          "Dit input er for langt."}
                      </span>
                    ) : null}
                  </div>
                  <div className={`form__field form__field--text is-filled is-bound ${this.state.vehicleModel?.length > 80 ? "is-invalid" : ""}`}>
                    <span className="form__valid" />
                    <input
                      className="form__item "
                      name="vehicleModel"
                      type="text"
                      disabled={isBookingActive ? true : false}
                      value={this.state.vehicleModel}
                      onChange={(event) => this.handleInputChange(event, 80)}
                    />
                    <label className="form__label">
                      <span className="form__label__text">
                        {textKeys.vehichleText ? textKeys.vehichleText.vehicleModel || "Model" : "Model"}&nbsp;&nbsp;<strong>&nbsp;</strong>
                      </span>
                    </label>
                    {this.state.vehicleModel?.length > 80 ? (
                      <span className="form__notice">
                        {this.props.validationMessageReplace(this.state.vehicleModel, vehicleValidationTextKeys.vehicleModelMessage) ||
                          "Dit input er for langt."}
                      </span>
                    ) : null}
                  </div>
                  <div className={`form__field form__field--text is-filled is-bound ${this.state.vehicleColour?.length > 20 ? "is-invalid" : ""}`}>
                    <span className="form__valid" />
                    <input
                      className="form__item "
                      name="vehicleColour"
                      type="text"
                      disabled={isBookingActive ? true : false}
                      value={this.state.vehicleColour}
                      onChange={(event) => this.handleInputChange(event, 20)}
                    />
                    <label className="form__label">
                      <span className="form__label__text">
                        {textKeys.vehichleText ? textKeys.vehichleText.vehicleColour || "Farve" : "Farve"}&nbsp;&nbsp;<strong>&nbsp;</strong>
                      </span>
                    </label>
                    {this.state.vehicleColour?.length > 20 ? (
                      <span className="form__notice">
                        {this.props.validationMessageReplace(this.state.vehicleColour, vehicleValidationTextKeys.vehicleColourMessage) ||
                          "Dit input er for langt."}
                      </span>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="deck deck--white deck--extra-padding-bottom">
          <div className="w--narrow center-buttons">
            <footer className="info-action-buttons">
              <p className="info--save-changes-disclaimer">
                {textKeys.infoDisclaimer || "Når du trykker 'Gem ændringer' modtager du en ny ordrebekræftelse med dine opdaterede informationer."}
              </p>
              <button
                className="button button--medium button--general rm-this-class rm-this-class-hide-default"
                onClick={() => this.handleModitfyInformation(this.state)}
              >
                <span className="icon">
                  <svg className="svg-icon svg-icon--planeduo">
                    <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-planeduo">
                      &nbsp;
                    </use>
                  </svg>
                </span>
                <span className="text">{textKeys.confirmButton || "Gem ændringer"}</span>
              </button>
              <Link to={`${path.AMMEND_SHOW_BOOKING()}${this.props.location.search}`} className="link">
                {textKeys.cancelButton || "Annullér"}
              </Link>
            </footer>
          </div>
        </section>
        {this.state.showErrorModal ? (
          <SimpleErrorModal errorData={this.state.errorData} modalOpen={this.state.modalOpen} closeHandler={this.handleModalClose} />
        ) : (
          ""
        )}
      </React.Fragment>
    )
  }
}
export default AmendInformation
